import { boot } from '@giscube/geoportal-ee';
import config from 'src/config';
export default boot({
  config: config
});